module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "5px",
      "#margin-left": "3px"
    },
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "capTop"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7013f8da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 456
// module chunks = 1